import { Chip, TextField, InputAdornment, Stack } from '@mui/material';
import {
    Group as GroupIcon,
    CheckCircle as CheckCircleIcon,
    Cancel as CancelIcon,
    SupervisorAccount as SupervisorAccountIcon,
    Search as SearchIcon,
} from '@mui/icons-material';
import { themeConstants } from '@/theme';
import { useI18nContext } from '@/i18n/i18n-react';

interface FilterBarProps {
    filterMode: 'all' | 'active' | 'inactive' | 'admin';
    onFilterModeChange: (mode: 'all' | 'active' | 'inactive' | 'admin') => void;
    searchQuery: string;
    onSearchChange: (query: string) => void;
}

export const FilterBar = ({
    filterMode,
    onFilterModeChange,
    searchQuery,
    onSearchChange,
}: FilterBarProps) => {
    const { LL } = useI18nContext();

    const chipStyles = {
        fontWeight: 600,
        transition: themeConstants.transitions.standard,
    };

    return (
        <Stack direction="row" sx={{ flexWrap: 'wrap', alignItems: 'center', gap: 2, mb: 2 }}>
            <TextField
                size="small"
                placeholder={LL.filterBar.searchPlaceholder()}
                value={searchQuery}
                onChange={(e) => onSearchChange(e.target.value)}
                slotProps={{
                    input: {
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon />
                            </InputAdornment>
                        ),
                    },
                }}
                sx={{
                    flex: 1,
                    minWidth: 200,
                    '& .MuiOutlinedInput-root': {
                        backgroundColor: 'background.paper',
                    },
                }}
            />
            <Chip
                label={LL.filterBar.all()}
                icon={<GroupIcon />}
                onClick={() => onFilterModeChange('all')}
                color={filterMode === 'all' ? 'primary' : 'default'}
                variant={filterMode === 'all' ? 'filled' : 'outlined'}
                sx={chipStyles}
            />
            <Chip
                label={LL.filterBar.active()}
                icon={<CheckCircleIcon />}
                onClick={() => onFilterModeChange('active')}
                color={filterMode === 'active' ? 'success' : 'default'}
                variant={filterMode === 'active' ? 'filled' : 'outlined'}
                sx={chipStyles}
            />
            <Chip
                label={LL.filterBar.inactive()}
                icon={<CancelIcon />}
                onClick={() => onFilterModeChange('inactive')}
                color={filterMode === 'inactive' ? 'error' : 'default'}
                variant={filterMode === 'inactive' ? 'filled' : 'outlined'}
                sx={chipStyles}
            />
            <Chip
                label={LL.filterBar.admin()}
                icon={<SupervisorAccountIcon />}
                onClick={() => onFilterModeChange('admin')}
                color={filterMode === 'admin' ? 'warning' : 'default'}
                variant={filterMode === 'admin' ? 'filled' : 'outlined'}
                sx={chipStyles}
            />
        </Stack>
    );
};
